(() => {
  // ===== Swipe/touch gesture helper (mobile: browse photos with a finger swipe) =====
  const addSwipeListener = (el, onSwipeLeft, onSwipeRight) => {
    let startX = 0;
    let startY = 0;
    let tracking = false;
    el.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    el.addEventListener('touchend', (e) => {
      if (!tracking) return;
      tracking = false;
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      const THRESHOLD = 40;
      if (Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) { onSwipeLeft(); } else { onSwipeRight(); }
      }
    }, { passive: true });
  };

  // ===== Thumbnail -> main image swap =====
  const setActiveImage = (group, thumb) => {
    const main = group.querySelector('.product-gallery__main-img');
    if (!main || !thumb) return;
    main.src = thumb.dataset.src;
    main.setAttribute('data-full', thumb.dataset.full);
    group.querySelectorAll('.product-gallery__thumb').forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
    if (thumb.scrollIntoView) { thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
  };

  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;
    const group = thumb.closest('[data-lightbox-group]');
    if (!group) return;
    setActiveImage(group, thumb);
  });

  // Swipe left/right on the big main photo: move to the next/previous thumbnail
  document.querySelectorAll('.product-gallery').forEach((group) => {
    const main = group.querySelector('.product-gallery__main-img');
    if (!main) return;
    const step = (dir) => {
      const thumbs = Array.from(group.querySelectorAll('.product-gallery__thumb'));
      if (thumbs.length < 2) return;
      const activeIdx = thumbs.findIndex((t) => t.classList.contains('is-active'));
      const cur = activeIdx < 0 ? 0 : activeIdx;
      const next = (cur + dir + thumbs.length) % thumbs.length;
      setActiveImage(group, thumbs[next]);
    };
    addSwipeListener(main, () => step(1), () => step(-1));
  });

  // ===== Lightbox (click main image to enlarge, with prev/next through all photos) =====
  const overlay = document.createElement('div');
  overlay.className = 'rafet-lightbox';
  overlay.innerHTML = '<button type="button" class="rafet-lightbox__close" aria-label="Fermer">×</button><button type="button" class="rafet-lightbox__nav rafet-lightbox__prev" aria-label="Précédent">‹</button><img alt=""><button type="button" class="rafet-lightbox__nav rafet-lightbox__next" aria-label="Suivant">›</button>';
  if (document.body) { document.body.appendChild(overlay); } else { document.addEventListener('DOMContentLoaded', () => document.body.appendChild(overlay)); }

  const imgEl = overlay.querySelector('img');
  const closeBtn = overlay.querySelector('.rafet-lightbox__close');
  const prevBtn = overlay.querySelector('.rafet-lightbox__prev');
  const nextBtn = overlay.querySelector('.rafet-lightbox__next');
  let gallery = [];
  let index = 0;

  const buildGalleryFromGroup = (group) => {
    const thumbs = group.querySelectorAll ? group.querySelectorAll('.product-gallery__thumb') : [];
    if (thumbs.length) {
      return Array.from(thumbs).map((t) => ({ src: t.dataset.src, full: t.dataset.full }));
    }
    const imgs = group.querySelectorAll ? group.querySelectorAll('.js-lightbox') : [];
    return Array.from(imgs).map((im) => ({ src: im.currentSrc || im.src, full: im.getAttribute('data-full') || im.currentSrc || im.src }));
  };

  const show = (i) => {
    if (!gallery.length) return;
    index = (i + gallery.length) % gallery.length;
    const item = gallery[index];
    imgEl.src = item.full || item.src;
    prevBtn.style.display = gallery.length > 1 ? '' : 'none';
    nextBtn.style.display = gallery.length > 1 ? '' : 'none';
  };

  const open = (triggerImg) => {
    const group = triggerImg.closest('[data-lightbox-group]') || document;
    gallery = buildGalleryFromGroup(group);
    const activeThumb = group.querySelector ? group.querySelector('.product-gallery__thumb.is-active') : null;
    if (activeThumb) {
      index = Array.from(group.querySelectorAll('.product-gallery__thumb')).indexOf(activeThumb);
    } else {
      const currentSrc = triggerImg.currentSrc || triggerImg.src;
      index = gallery.findIndex((g) => g.src === currentSrc);
      if (index < 0) index = 0;
    }
    show(index);
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  };
  const close = () => {
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.js-lightbox');
    if (trigger) { open(trigger); }
  });
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
  prevBtn.addEventListener('click', () => show(index - 1));
  nextBtn.addEventListener('click', () => show(index + 1));
  document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(index - 1);
    if (e.key === 'ArrowRight') show(index + 1);
  });

  // Swipe left/right inside the open lightbox to browse photos with a finger
  addSwipeListener(overlay, () => show(index + 1), () => show(index - 1));
})();
